import { changeJobName, setChangeJobNameStatus } from "actions/jobs";
import SageButton from "kit/SageButton";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import changeJobNameStatusSelector from "selectors/changeJobNameStatus";

interface Props {
    job: sage.model.IJob | undefined;
}

const ChangeNameDialog: React.FC<Props> = ({ job }) => {
    const [currName, setCurrName] = React.useState(job ? job.name || "" : "");
    const changeJobNameStatus = useSelector(changeJobNameStatusSelector);
    const dispatch = useDispatch();
    const onCurrNameChanged = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setCurrName(e.target.value);
        },
        [setCurrName]
    );
    React.useEffect(() => {
        dispatch(setChangeJobNameStatus("none"));
    }, [dispatch]);

    const onFormSubmit = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            if (job) {
                dispatch(changeJobName(currName, job.id));
            }
        },
        [dispatch, job, currName]
    );

    if (!job) {
        return null;
    }

    return (
        <div className="modal fade" id="changeNameModal" aria-hidden={true}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Change Job Name</h5>
                    </div>
                    <form onSubmit={onFormSubmit}>
                        <div className="modal-body">
                            <div className="form-group">
                                <label className="recipient-name col-form-label">
                                    New Name
                                </label>
                                <input
                                    onChange={onCurrNameChanged}
                                    value={currName}
                                    type="text"
                                    className="form-control"
                                    id="recipient-name"
                                />
                            </div>
                            {changeJobNameStatus === "error" ? (
                                <div
                                    className="alert alert-danger"
                                    role="alert"
                                >
                                    An error occurred changing the name of your
                                    job.
                                </div>
                            ) : null}
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <SageButton
                                loading={changeJobNameStatus === "loading"}
                                type="submit"
                                text="Save"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangeNameDialog;
